import {
    Stack,
    Tabs,
    Divider,
    Tab,
    TabProps,
    styled,
    Typography,
    Box
} from "@mui/material";
import TabPanel from "components/tabPanel";
import CoderView from "./coderView";
import DoctorView from "./doctorView";
import { useEncounter } from "../encounter.provider";
import { isEmpty } from "lodash";
import SimpleBar from "simplebar-react";

const StyledTab = styled(({ ...props }: TabProps) => <Tab {...props} />)(
    ({ theme }) => ({
        "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4
        }
    })
);

const DiagnosisInfo = () => {
    const { encounterForm, fetchedEncounter, onChangeTab, activeTab } =
        useEncounter();

    const { watch } = encounterForm;

    const [transactionNumber, hospitalNumber] = watch([
        "transactionNumber",
        "hospitalNumber"
    ]);

    if (
        isEmpty(transactionNumber) ||
        isEmpty(hospitalNumber) ||
        !fetchedEncounter
    ) {
        return (
            <Stack width="100%" spacing={1} textAlign="center">
                <Typography variant="subtitle1">
                    Please Fill Hospital Number and Transaction Number
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack width="100%" spacing={1}>
            <Tabs
                value={activeTab}
                onChange={onChangeTab}
                textColor="primary"
                variant="fullWidth"
                indicatorColor="primary"
            >
                <StyledTab value="doctor" label="Doctor" />
                <StyledTab value="coder" label="Coder" />
            </Tabs>
            <Divider />
            <Box
                component={SimpleBar}
                sx={{ height: "calc(100vh - 300px)", overflow: "auto" }}
            >
                <TabPanel value={activeTab} index="doctor">
                    <DoctorView />
                </TabPanel>
                <TabPanel value={activeTab} index="coder">
                    <CoderView />
                </TabPanel>
            </Box>
        </Stack>
    );
};

export default DiagnosisInfo;
